import { render } from "./ContractTemplatesDashboard.vue?vue&type=template&id=59eff6f4&scoped=true"
import script from "./ContractTemplatesDashboard.vue?vue&type=script&lang=js"
export * from "./ContractTemplatesDashboard.vue?vue&type=script&lang=js"

import "./ContractTemplatesDashboard.vue?vue&type=style&index=0&id=59eff6f4&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59eff6f4"]])

export default __exports__